module.exports = __webpack_public_path__ + "static/img/sebei.95ea402.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sebei.png
// module id = rjvP
// module chunks = 69